import React, { forwardRef } from "react";
import SimpleBar from "simplebar-react";
import { cn, getFocusRingStyles } from "../../styles";
import { ThemeColor } from "../../props";

export type ScrollDirection = "vertical" | "horizontal" | "both";

export interface ScrollAreaProps {
  children?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  style?: React.CSSProperties;
  direction?: ScrollDirection;
  autoHide?: boolean;
  tabIndex?: number;
}

export const ScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(
  (
    {
      className,
      contentClassName = "",
      children,
      direction = "vertical",
      style,
      autoHide = true,
      tabIndex,
    },
    ref,
  ) => {
    return (
      <SimpleBar
        scrollableNodeProps={{
          ref,
          className: cn(
            "outline-none focus-visible:ring-2 focus-visible:ring-inset rounded",
            getFocusRingStyles(ThemeColor.primary),
          ),
        }}
        className={cn(
          direction === "vertical" && "overflow-x-hidden",
          direction === "horizontal" && "overflow-y-hidden",
          className,
        )}
        {...(contentClassName
          ? {
              classNames: {
                contentEl: cn("simplebar-content", contentClassName),
              },
            }
          : {})}
        {...{ style, autoHide, tabIndex }}
      >
        {children}
      </SimpleBar>
    );
  },
);

ScrollArea.displayName = "ScrollArea";
